import { motion, useInView } from "framer-motion"
import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react"
import { Color } from "../../../utilities/colors"
import "./campaign-talents-landing-card.scss"


interface Props {
    className?: string
}

const CampaignTalentsLandingCard = (props: Props) => {

    const talentWrapperRef = useRef<HTMLDivElement>(null)
    const inView = useInView(talentWrapperRef, { amount: 1, once: true });

    const talentPillRefs = useRef<TalentPillRef[]>([]);

    useEffect(() => {
        if (!talentPillRefs.current) return
        for (let talentPill of talentPillRefs.current) {
            talentPill.toggleActivation(inView)
        }
    }, [inView])


    return (
        <div ref={talentWrapperRef}>
            <div className='emrg-demo-cards talent-main-card-wrapper'>
                <div className='card-header'>
                    <h3>Shortlist the right talent for the job</h3>
                    <p className='color-gray-300'>Get the ideal talents for your campaign from our vast talent pool and trusted agencies.</p>
                </div>
                <div className="talent-wrapper">
                    <div className="talent-row">
                        <div>
                            <TalentPill />
                        </div>
                        <div>
                            <TalentPill />
                        </div>
                        <div>
                            <TalentPill />
                        </div>
                        <div>
                            <TalentPill ref={(el: TalentPillRef) => (talentPillRefs.current[0] = el)}
                                sequence={0}
                                src={"https://randompicturegenerator.com/img/people-generator/g167cc57243fe6f6c729e12865ad5dfa85070cba34876f0383cf9ed9dc743ebe29bb4b8f8cfdb8fd31780cf03757b94c0_640.jpg"}
                                name={"Gibson Gray"} />
                        </div>
                        <div>
                            <TalentPill />
                        </div>

                        <div>
                            <TalentPill ref={(el: TalentPillRef) => (talentPillRefs.current[1] = el)}
                                sequence={1}
                                src={"https://randompicturegenerator.com/img/people-generator/gfc47389984697c096f32cff6ef7f6a08ca7c646ac3d1766aeaa987c4404267bb8fb6877a32229a86121ff842e0fd7553_640.jpg"}
                                name={"Hector Blake"} />
                        </div>
                        <div>
                            <TalentPill />
                        </div>
                        <div>
                            <TalentPill />
                        </div>
                        <div>
                            <TalentPill />
                        </div>
                        <div>
                            <TalentPill />
                        </div>
                    </div>
                    <div className="talent-row mt-3 offset-1">
                        <div>
                            <TalentPill />
                        </div>
                        <div>
                            <TalentPill />
                        </div>
                        <div>
                            <TalentPill />
                        </div>
                        <div>
                            <TalentPill />
                        </div>
                        <div>
                            <TalentPill />
                        </div>
                        <div>
                            <TalentPill ref={(el: TalentPillRef) => (talentPillRefs.current[2] = el)}
                                sequence={2}
                                src={"https://randompicturegenerator.com/img/people-generator/g69b41a50682984f0e04b9720b4dc30d30e91cabaa59cdc4edf0dd41918f85cd798335f5b3d69811ad9b191d51839a79c_640.jpg"}
                                name={"Baron Mors"} />
                        </div>
                        <div>
                            <TalentPill ref={(el: TalentPillRef) => (talentPillRefs.current[3] = el)}
                                sequence={3}
                                src={"https://randompicturegenerator.com/img/people-generator/g4f68831350bd317703978af352844dbd5c83efdea055fa5dfcab30ff0751ec3bd584fbf3c7c9cac25062e59523c13b1d_640.jpg"}
                                name={"Holland Reese"} />
                        </div>
                        <div>
                            <TalentPill ref={(el: TalentPillRef) => (talentPillRefs.current[4] = el)}
                                sequence={4}
                                src={"https://randompicturegenerator.com/img/people-generator/g2f49885fd940d1ae3f9e51caf7196b46a86de73e2f011eb622ec0b4fdca3e3ff91289cacce845d8e564d5658f6bd7b2d_640.jpg"}
                                name={"Dwayne Sawyer"} />
                        </div>
                        <div>
                            <TalentPill />
                        </div>
                        <div>
                            <TalentPill />
                        </div>
                    </div>
                    <div className="talent-row mt-3">
                        <div>
                            <TalentPill />

                        </div>
                        <div>
                            <TalentPill />
                        </div>
                        <div>
                            <TalentPill />
                        </div>
                        <div>
                            <TalentPill />
                        </div>
                        <div>
                            <TalentPill ref={(el: TalentPillRef) => (talentPillRefs.current[5] = el)}
                                sequence={5}
                                src="https://randompicturegenerator.com/img/people-generator/gaf722d5be9f30c451871dd1dc75669b6f56a086941a0bc27d822b3b2f7e4b0a291b672326d65b6e92b76211c652487c5_640.jpg"
                                name={"Ducky Sage"} />
                        </div>
                        <div>
                            <TalentPill />
                        </div>
                        <div>
                            <TalentPill ref={(el: TalentPillRef) => (talentPillRefs.current[6] = el)}
                                sequence={6}
                                src="https://randompicturegenerator.com/img/people-generator/g2bfdc4b0262bd2f27022d75638e32374acd960dd50a7cc55cc67e1503359c0321946da810c7cca31a879f1049708c609_640.jpg"
                                name={"Smash Wang"} />
                        </div>
                        <div>
                            <TalentPill />
                        </div>
                        <div>
                            <TalentPill />
                        </div>
                        <div>
                            <TalentPill />
                        </div>
                    </div>
                </div>

            </div>
        </div>
    )
}
export default CampaignTalentsLandingCard


interface TalentPillProps {
    name?: string
    src?: string
    sequence?: number
}
interface TalentPillRef {
    toggleActivation: (isActivated: boolean) => void
}

const TalentPill = forwardRef((props: TalentPillProps, ref) => {

    const { name, src, sequence } = props;

    const formattedName = name ? name : "John Doe"
    const BASE_DELAY_S = 0.5
    const SEQUENCE_DELAY_S = sequence !== undefined ? BASE_DELAY_S + 0.1 * sequence : 0;
    const talentPillElemRef = useRef<HTMLDivElement>(null)
    const [isActivated, setActivated] = useState(false)


    const talentPillVariants = {
        skeletal: {
            backgroundColor: Color.NEUTRAL[800],
            borderColor: Color.NEUTRAL[700],
            boxShadow: "0px 0px 0px 0px rgba(0, 0, 0, 0.15)",
            transition: { duration: 0.5 }
        },
        filled: {
            backgroundColor: Color.NEUTRAL[750],
            borderColor: Color.NEUTRAL[750],
            boxShadow: "0px 16px 40px 10px rgba(0, 0, 0, 0.15)",
        }
    }
    const talentNameWrapperVariants = {
        skeletal: { borderColor: Color.NEUTRAL[700], transition: { duration: 0.5 } },
        filled: { borderColor: Color.NEUTRAL[750] }
    }
    const talentNameVariants = {
        skeletal: { opacity: 0, transition: { duration: 0.5 } },
        filled: { opacity: 1 }
    }
    const talentImgVariants = {
        skeletal: { scale: 0, transition: { duration: 0.5 } },
        filled: { scale: 1 }
    }

    useImperativeHandle(ref, () => {
        return {
            toggleActivation,
        };
    })

    const toggleActivation = (isActivated: boolean) => {
        if (sequence === undefined) return
        setActivated(isActivated)
    }



    return <motion.div className="talent-pill"
        ref={talentPillElemRef}
        initial="skeletal"
        variants={talentPillVariants}
        transition={{ delay: SEQUENCE_DELAY_S }}
        animate={isActivated ? "filled" : "skeletal"}>
        <div className="content">
            <motion.div
                initial="skeletal"
                variants={talentNameWrapperVariants}
                animate={isActivated ? "filled" : "skeletal"}
                transition={{ delay: SEQUENCE_DELAY_S }}
                className="display-img">
                <motion.img
                    initial="skeletal"
                    variants={talentImgVariants}
                    animate={isActivated ? "filled" : "skeletal"}
                    transition={{ delay: SEQUENCE_DELAY_S }}
                    alt="talent"
                    src={src} />
            </motion.div>
            <motion.div className="name-wrapper"
                initial="skeletal"
                variants={talentNameWrapperVariants}
                transition={{ delay: SEQUENCE_DELAY_S }}
                animate={isActivated ? "filled" : "skeletal"}>

                <motion.span
                    initial="skeletal"
                    variants={talentNameVariants}
                    animate={isActivated ? "filled" : "skeletal"}
                    transition={{ delay: SEQUENCE_DELAY_S }}
                >{formattedName}</motion.span>
            </motion.div>
        </div>
    </motion.div>
})